import * as React from 'react';
// mui
import { Gauge } from '@mui/x-charts/Gauge';
import { Card, Container, Typography } from '@mui/material';
// dayjs
import dayjs from 'dayjs';
// redux
import { useSelector } from 'react-redux';
import { selectAllEvents, selectCompleteEvents } from '../../store/selectors/eventSelectors';
import { selectAllRecurringTasks, selectCompleteRecurringTasks } from '../../store/selectors/recuringTaskSelectors';
import { selectAllTasks, selectCompleteTasks } from '../../store/selectors/taskSelectors';
// types
import Event from '../../interfaces/Event.interface';
import Task from '../../interfaces/Task.interface';
import RecurringTask from '../../interfaces/RecurringTask.interface';

export default function DueTodayGauge() {
  const currentDate = dayjs().startOf('day').utc();

  const taskDueTodayFilter = (task: Task) => dayjs.utc(task.dueDate).isSame(currentDate);
  const localTasks: Task[] = useSelector(selectAllTasks()).filter(taskDueTodayFilter);
  const localCompleteTasks: Task[] = useSelector(selectCompleteTasks()).filter(taskDueTodayFilter);
  
  const recurringTaskDueTodayFilter = (task: RecurringTask) => dayjs.utc(task.dueDate).isSame(currentDate) && !task.permanentlyCompleted;
  const localRecurringTasks: RecurringTask[] = useSelector(selectAllRecurringTasks()).filter(recurringTaskDueTodayFilter);
  const localCompleteRecurringTasks: RecurringTask[] = useSelector(selectCompleteRecurringTasks()).filter(recurringTaskDueTodayFilter);

  const eventStartDateFilter = (event: Event) => dayjs.utc(event.startTime).local().startOf('day').utc().isSame(currentDate);
  const localEvents: Event[] = useSelector(selectAllEvents()).filter(eventStartDateFilter);
  const localCompleteEvents: Event[] = useSelector(selectCompleteEvents()).filter(eventStartDateFilter);

  const totalItems: number = localTasks.length + localRecurringTasks.length + localEvents.length;
  const totalComplete: number = localCompleteTasks.length + localCompleteRecurringTasks.length + localCompleteEvents.length;

  return (
    <Card sx={{ p: 2, height: '100%' }} variant="outlined">
      <Container sx={{ width: '100%', mt: 6, display: 'flex', alignContent: 'center' }}>
        <Gauge
          width={150}
          height={150}
          value={totalComplete}
          valueMax={totalItems}
          text={({ value, valueMax }) => `${value} / ${valueMax}`}
        />
      </Container>
      <Typography sx={{ textAlign: 'center' }} variant='h6'>Items Completed</Typography>
      <Typography sx={{ textAlign: 'center' }} variant='body1'>Of All Items Due Today</Typography>
    </Card>
  )
}
